<template>
  <div>
    <h1>
      Ups... Error Loading this page.
    </h1>
  </div>
</template>

<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL
    };
  }
};
</script>
